// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOrganizationPropertyInfoDto
 */
export interface IOrganizationPropertyInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    id?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    organization_id?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationPropertyInfoDto
     */
    tax_id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    incoming_clearing_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    notional_clearing_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    hsa_clearing_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    administrator_fees_clearing_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    unspecified_clearing_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    notional_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    hsa_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    replenishment_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    external_replenishment_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    external_payroll_contributions_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    external_administrator_fees_account?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationPropertyInfoDto
     */
    external_account_enable?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    account_manager_id?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    notional_source_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    invoicing_contact_id?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    inter_prefund_replenishment_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    final_prefund_replenishment_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    payroll_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    organization_fee_clearing_account?: number;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    write_off_account?: number;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    fee_clearing_account?: number;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    contribution_clearing_account?: number;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationPropertyInfoDto
     */
    claim_note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    notional_record_keeping_account?: number;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    external_push_return_account?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    unapplied_push_clearing_account?: number;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationPropertyInfoDto
     */
    external_balance_adjustment_account?: number | null;
}

/**
 * Check if a given object implements the IOrganizationPropertyInfoDto interface.
 */
export function instanceOfIOrganizationPropertyInfoDto(value: object): value is IOrganizationPropertyInfoDto {
    return true;
}

export function IOrganizationPropertyInfoDtoFromJSON(json: any): IOrganizationPropertyInfoDto {
    return IOrganizationPropertyInfoDtoFromJSONTyped(json, false);
}

export function IOrganizationPropertyInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrganizationPropertyInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'tax_id': json['tax_id'] == null ? undefined : json['tax_id'],
        'incoming_clearing_account': json['incoming_clearing_account'] == null ? undefined : json['incoming_clearing_account'],
        'notional_clearing_account': json['notional_clearing_account'] == null ? undefined : json['notional_clearing_account'],
        'hsa_clearing_account': json['hsa_clearing_account'] == null ? undefined : json['hsa_clearing_account'],
        'administrator_fees_clearing_account': json['administrator_fees_clearing_account'] == null ? undefined : json['administrator_fees_clearing_account'],
        'unspecified_clearing_account': json['unspecified_clearing_account'] == null ? undefined : json['unspecified_clearing_account'],
        'notional_account': json['notional_account'] == null ? undefined : json['notional_account'],
        'hsa_account': json['hsa_account'] == null ? undefined : json['hsa_account'],
        'replenishment_account': json['replenishment_account'] == null ? undefined : json['replenishment_account'],
        'external_replenishment_account': json['external_replenishment_account'] == null ? undefined : json['external_replenishment_account'],
        'external_payroll_contributions_account': json['external_payroll_contributions_account'] == null ? undefined : json['external_payroll_contributions_account'],
        'external_administrator_fees_account': json['external_administrator_fees_account'] == null ? undefined : json['external_administrator_fees_account'],
        'external_account_enable': json['external_account_enable'] == null ? undefined : json['external_account_enable'],
        'account_manager_id': json['account_manager_id'] == null ? undefined : json['account_manager_id'],
        'notional_source_account': json['notional_source_account'] == null ? undefined : json['notional_source_account'],
        'invoicing_contact_id': json['invoicing_contact_id'] == null ? undefined : json['invoicing_contact_id'],
        'inter_prefund_replenishment_account': json['inter_prefund_replenishment_account'] == null ? undefined : json['inter_prefund_replenishment_account'],
        'final_prefund_replenishment_account': json['final_prefund_replenishment_account'] == null ? undefined : json['final_prefund_replenishment_account'],
        'payroll_account': json['payroll_account'] == null ? undefined : json['payroll_account'],
        'organization_fee_clearing_account': json['organization_fee_clearing_account'] == null ? undefined : json['organization_fee_clearing_account'],
        'write_off_account': json['write_off_account'] == null ? undefined : json['write_off_account'],
        'fee_clearing_account': json['fee_clearing_account'] == null ? undefined : json['fee_clearing_account'],
        'contribution_clearing_account': json['contribution_clearing_account'] == null ? undefined : json['contribution_clearing_account'],
        'claim_note': json['claim_note'] == null ? undefined : json['claim_note'],
        'notional_record_keeping_account': json['notional_record_keeping_account'] == null ? undefined : json['notional_record_keeping_account'],
        'external_push_return_account': json['external_push_return_account'] == null ? undefined : json['external_push_return_account'],
        'unapplied_push_clearing_account': json['unapplied_push_clearing_account'] == null ? undefined : json['unapplied_push_clearing_account'],
        'external_balance_adjustment_account': json['external_balance_adjustment_account'] == null ? undefined : json['external_balance_adjustment_account'],
    };
}

export function IOrganizationPropertyInfoDtoToJSON(json: any): IOrganizationPropertyInfoDto {
    return IOrganizationPropertyInfoDtoToJSONTyped(json, false);
}

export function IOrganizationPropertyInfoDtoToJSONTyped(value?: IOrganizationPropertyInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organization_id': value['organization_id'],
        'tax_id': value['tax_id'],
        'incoming_clearing_account': value['incoming_clearing_account'],
        'notional_clearing_account': value['notional_clearing_account'],
        'hsa_clearing_account': value['hsa_clearing_account'],
        'administrator_fees_clearing_account': value['administrator_fees_clearing_account'],
        'unspecified_clearing_account': value['unspecified_clearing_account'],
        'notional_account': value['notional_account'],
        'hsa_account': value['hsa_account'],
        'replenishment_account': value['replenishment_account'],
        'external_replenishment_account': value['external_replenishment_account'],
        'external_payroll_contributions_account': value['external_payroll_contributions_account'],
        'external_administrator_fees_account': value['external_administrator_fees_account'],
        'external_account_enable': value['external_account_enable'],
        'account_manager_id': value['account_manager_id'],
        'notional_source_account': value['notional_source_account'],
        'invoicing_contact_id': value['invoicing_contact_id'],
        'inter_prefund_replenishment_account': value['inter_prefund_replenishment_account'],
        'final_prefund_replenishment_account': value['final_prefund_replenishment_account'],
        'payroll_account': value['payroll_account'],
        'organization_fee_clearing_account': value['organization_fee_clearing_account'],
        'write_off_account': value['write_off_account'],
        'fee_clearing_account': value['fee_clearing_account'],
        'contribution_clearing_account': value['contribution_clearing_account'],
        'claim_note': value['claim_note'],
        'notional_record_keeping_account': value['notional_record_keeping_account'],
        'external_push_return_account': value['external_push_return_account'],
        'unapplied_push_clearing_account': value['unapplied_push_clearing_account'],
        'external_balance_adjustment_account': value['external_balance_adjustment_account'],
    };
}

